import React from 'react';
import { FaBookmark } from 'react-icons/fa6';
import { Button } from '@benzinga/core-ui';
import { useWatchlistsLoading } from '@benzinga/watchlist-manager-hooks';

export interface WatchlistCTABannerProps {
  createUrl?: string;
  customizeUrl?: string;
}

const DEFAULT_CREATE_URL = '/profile/portfolio/?action=create-watchlist&utm_source=homepage-watchlist-prompt';
const DEFAULT_CUSTOMIZE_URL = '/profile/portfolio/?utm_source=homepage-watchlist-prompt';

export const WatchlistCTABanner: React.FC<WatchlistCTABannerProps> = ({
  createUrl = DEFAULT_CREATE_URL,
  customizeUrl = DEFAULT_CUSTOMIZE_URL,
}) => {
  const { watchlists } = useWatchlistsLoading();
  const hasWatchlists = watchlists.length > 0;
  const targetUrl = hasWatchlists ? customizeUrl : createUrl;

  return (
    <div className="@container">
      <a
        className="relative block w-full min-h-12 overflow-hidden rounded-lg no-underline bg-[#1D222C]
        bg-[url('/next-assets/images/watchlist-widget-background.png')]
        @[720px]:bg-[url('/next-assets/images/watchlist-prompt-banner-background.png')]
        bg-bottom @[720px]:bg-right bg-no-repeat bg-cover @[720px]:bg-contain"
        href={targetUrl}
        rel="noreferrer"
        target="_blank"
      >
        <div className="absolute inset-0 bg-gradient-to-r from-[#1D222C] from-50% to-transparent" />
        <div className="relative flex flex-col @[720px]:flex-row items-start @[720px]:items-center gap-3 w-full px-4 py-3">
          {hasWatchlists ? (
            <div className="bg-blue-500/10 border border-bzgray-800 rounded-lg p-2">
              <FaBookmark className="w-4 h-4 stroke-1 stroke-blue-500 fill-blue-500" />
            </div>
          ) : (
            <div className="px-1.5 py-[0.05rem] bg-blue-50 backdrop-blur-sm rounded">
              <span className="text-blue-500 text-sm font-bold tracking-wide">FREE</span>
            </div>
          )}
          <div className="flex flex-col @[720px]:flex-row @[720px]:items-center gap-2 min-w-0">
            <span className="text-white text-lg @[720px]:text-sm font-bold tracking-wide uppercase">
              {hasWatchlists ? 'MY BENZINGA WATCHLIST' : 'REGISTER TO HAVE YOUR OWN WATCHLIST'}
            </span>
            <span className="text-gray-400 text-sm @[720px]:text-xs truncate @[720px]:inline @[720px]:ml-2">
              {hasWatchlists ? 'Shape your feed — pick the stocks that matter to you.' : 'Track your favorite stocks'}
            </span>
          </div>
          <Button className="uppercase w-full h-[40px] @[720px]:w-auto @[720px]:h-auto" variant="flat-blue">
            {hasWatchlists ? 'CUSTOMIZE MY WATCHLIST' : 'CREATE WATCHLIST'}
          </Button>
        </div>
      </a>
    </div>
  );
};

export default WatchlistCTABanner;
